/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ParamedicReferralPayment from './paramedic-referral-payment';
import ParamedicReferralPaymentDetail from './paramedic-referral-payment-detail';
import ParamedicReferralPaymentUpdate from './paramedic-referral-payment-update';
import ParamedicReferralPaymentDeleteDialog from './paramedic-referral-payment-delete-dialog';

const ParamedicReferralPaymentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ParamedicReferralPayment />} />
    <Route path="new" element={<ParamedicReferralPaymentUpdate />} />
    <Route path=":id">
      <Route index element={<ParamedicReferralPaymentDetail />} />
      <Route path="edit" element={<ParamedicReferralPaymentUpdate />} />
      <Route path="delete" element={<ParamedicReferralPaymentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ParamedicReferralPaymentRoutes;
